export const appointmentStatusColorCode = [
    {
        label: "scheduled",
        colorBg: "bg-[#FEF3C7]",
        colorText: "text-[#92400E]"
    },
    {
        label: "queued",
        colorBg: "bg-[#d1eefa]",
        colorText: "text-[#073c50]"
    },
    {
        label: "inprogress",
        colorBg: "bg-[#DBEAFE]",
        colorText: "text-[#1E40AF]"
    },
    {
        label: "done",
        colorBg: "bg-[#DCFCE7]",
        colorText: "text-[#166534]"
    },
    {
        label: "inservice",
        colorBg: "bg-[#FFF7ED]",
        colorText: "text-[#9A3412]"
    },
    {
        label: "noshow",
        colorBg: "bg-gray-500",
        colorText: "text-white"
    },
    {
        label: "cancelled",
        colorBg: "bg-[#FEE2E2]",
        colorText: "text-[#991B1B]"
    },
    {
        label: "placed po",
        colorBg: "bg-[#DBEAFE]",
        colorText: "text-[#1D4ED8]"
    },
    {
        label: "received",
        colorBg: "bg-[#DCFCE7]",
        colorText: "text-[#166534]"
    },
    {
        label: "partially received",
        colorBg: "bg-[#FEF9C3]",
        colorText: "text-[#854D0E]"
    },
    {
        label: "returned",
        colorBg: "bg-[#FEE2E2]",
        colorText: "text-[#B91C1C]"
    },
    {
        label: "good",
        colorBg: "bg-[#DCFCE7]",
        colorText: "text-[#166534]"
    },
    {
        label: "ban",
        colorBg: "bg-[#FEE2E2]",
        colorText: "text-[#991B1B]"
    },
    {
        label: "returned",
        colorBg: "bg-[#FEE2E2]",
        colorText: "text-[#B91C1C]"
    },
    {
        label: "not credit",
        colorBg: "bg-[#DBEAFE]",
        colorText: "text-[#1D4ED8]"
    }
];
